module.exports = __webpack_public_path__ + "img/firstSergeantTroop.7ac59dd7.png";